<template functional>
  <div class="downloader-informer" :class="{ expanded: props.expanded }">
    <div :class="{ active: props.isContentDownloaded }">
      <component
        :is="injections.components.BaseSpriteIcon"
        icon-name="ico-book-new"
      ></component>
      <span v-if="props.expanded">
        <span v-if="props.isContentDownloaded">{{
          $options.methods.localize('DownloaderInformer.onDevice.label')
        }}</span>
        <span v-else>{{
          $options.methods.localize('DownloaderInformer.notOnDevice.label')
        }}</span>
      </span>
    </div>
    <div v-if="props.hasAudio" :class="{ active: props.isAudioDownloaded }">
      <component
        :is="injections.components.BaseSpriteIcon"
        icon-name="ico-sound"
      ></component>
      <span v-if="props.expanded"
        ><span v-if="props.isAudioDownloaded">{{
          $options.methods.localize('DownloaderInformer.onDevice.label')
        }}</span>
        <span v-else>{{
          $options.methods.localize('DownloaderInformer.notOnDevice.label')
        }}</span></span
      >
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n';
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';

export default {
  name: 'DownloadInformer',
  inject: {
    components: {
      default: {
        BaseSpriteIcon
      }
    }
  },
  props: {
    isContentDownloaded: {
      type: Boolean,
      required: false,
      default: false
    },
    isAudioDownloaded: {
      type: Boolean,
      required: false,
      default: false
    },
    hasAudio: {
      type: Boolean,
      required: false,
      default: false
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    localize(val) {
      return i18n.localize(val);
    }
  }
};
</script>

<style lang="less" src="./DownloadInformer.less"></style>
